import cnpjValidation from './cnpjValidation';
import cpfValidation from './cpfValidation';
import emailValidation from './emailValidation';
import passwordValidation from './passwordValidation';

export default {
  cnpjValidation,
  cpfValidation,
  emailValidation,
  passwordValidation,
};
